import { render } from "./CardHeader.vue?vue&type=template&id=154146e2&ts=true"
import script from "./CardHeader.vue?vue&type=script&lang=ts"
export * from "./CardHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__